import styles from './Toggle.module.css';

export type ToggleProps = {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  disabled?: boolean;
  /** Keeps the label as the accessible name but does not show it (e.g. a form grid shows it). */
  hideLabel?: boolean;
};

export function Toggle({
  checked,
  onChange,
  label,
  disabled = false,
  hideLabel = false,
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={styles['toggle']}
      onClick={() => onChange(!checked)}
    >
      <span className={styles['track']} aria-hidden="true">
        <span className={styles['thumb']} />
      </span>
      <span className={hideLabel ? styles['hiddenLabel'] : styles['label']}>{label}</span>
    </button>
  );
}
